module.exports = __webpack_public_path__ + "img/logo-after.353bb952.webp";